export enum EFinancialAccountModule {
    VENDAS = 'VENDAS',
    OUTROS = 'OUTROS',
}
